















import Vue from "vue";

export default Vue.extend({
  
  data() {
    return {
    };
  },
  created() {},
  methods:
  {
    setDailyStart(event)
    {
      this.$store.commit('sequence/setDailyStart', event.target.value)
    },
    setDailyEnd(event)
    {
      this.$store.commit('sequence/setDailyEnd', event.target.value)
    }
  }
});
